// @flow

import { cmsAxios } from '../axios-config';

const getInboxMessages = (conversationId) => {
  return cmsAxios.get(`/support-chat/conversations/${conversationId}/messages`);
};

export default getInboxMessages;
